import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Terms.css';

function TermsLayout({ children }) {
  const location = useLocation();

  const termsSections = [
    { path: '/terms/privacy-policy', label: 'Privacy Policy' },
    { path: '/terms/terms-of-service', label: 'Terms of Service' },
    { path: '/terms/data-processing-agreement', label: 'Data Processing Agreement' },
    { path: '/terms/acceptable-use', label: 'Acceptable Use Policy' },
    { path: '/terms/cookie-policy', label: 'Cookie Policy' },
    { path: '/terms/delete-account', label: 'Delete Account' },
  ];

  return (
    <div className="terms-page">
      <nav className="terms-nav">
        <div className="terms-nav-container">
          <Link to="/" className="terms-logo">
            <img src="/Zella logo green.png" alt="Zella" className="terms-logo-img" />
          </Link>
          <Link to="/" className="back-link">
            <svg viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
            Back to Home
          </Link>
        </div>
      </nav>

      <div className="terms-container">
        <aside className="terms-sidebar">
          <h3>Legal Documents</h3>
          <ul>
            {termsSections.map((section) => (
              <li key={section.path}>
                <Link
                  to={section.path}
                  className={location.pathname === section.path ? 'active' : ''}
                >
                  {section.label}
                </Link>
              </li>
            ))}
          </ul>
        </aside>

        <main className="terms-content">
          {children}
        </main>
      </div>
    </div>
  );
}

export default TermsLayout;